import { Modal } from '@farol-ds/react'
import { useEffect, useState } from 'react'

import { useModalContext } from '../context'

interface ModalLockProps {
  children: React.ReactNode
  modalSize?: ModalSize
}

type ModalSize = 'sm' | 'md' | 'lg'

const DEFAULT_MODAL_SIZE: ModalSize = 'sm'

export function ModalLock({ children, modalSize }: ModalLockProps) {
  const { setOpen } = useModalContext()
  const [size, setSize] = useState<ModalSize>(DEFAULT_MODAL_SIZE)

  useEffect(() => {
    setSize(modalSize || DEFAULT_MODAL_SIZE)
  }, [modalSize])

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setOpen(false)
    }
  }

  return (
    <Modal size={size} open onOpenChange={handleOpenChange}>
      <Modal.Content>
        <Modal.IconClose />
        <Modal.Header>
          <Modal.HeaderBrand />
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal.Content>
    </Modal>
  )
}
